module.exports = __webpack_public_path__ + "static/media/union.57480501.svg";